import React, { useState } from "react";
import {
  Button,
  FormControl,
  FormControlLabel,
  RadioGroup,
  FormLabel,
  Radio,
  Box,
} from "@mui/material";
import Alert from "@mui/material/Alert";

function CloseTripForm3({ nextStep, prevStep, handleChange, values }) {
  const [errors, setErrors] = useState({});

  const formIsValid = () => {
    const formErrors = {};
    if (values.mnkfshOvrFlg === "" || values.mnkfshOvrFlg === undefined)
      formErrors.mnkfshOvrFlg =
        "Select a valid value for the Monkfish trip limit overage.";

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const _next = (event) => {
    event.preventDefault();
    if (!formIsValid()) return;

    nextStep();
  };

  const _cancel = (event) => {
    event.preventDefault();
    prevStep();
  };

  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        m={1}
        p={1}
        bgcolor="background.paper"
      >
        <FormControl variant="standard" component="fieldset">
          <FormLabel component="legend">
            Are you declaring a Monkfish trip limit overage?
          </FormLabel>
          <RadioGroup
            name="mnkfshOvrFlg"
            id="mnkfshOvrFlg"
            value={values.mnkfshOvrFlg}
            onChange={handleChange("mnkfshOvrFlg")}
            row
            className="justifyCenter"
          >
            <FormControlLabel
              value="true"
              control={<Radio color="primary" />}
              label="Yes"
            />
            <FormControlLabel
              value="false"
              control={<Radio color="primary" />}
              label="No"
            />
          </RadioGroup>
        </FormControl>
      </Box>
      {errors.mnkfshOvrFlg && (
        <Alert severity="error">{errors.mnkfshOvrFlg}</Alert>
      )}
      <Box display="flex" justifyContent="center" m={1} p={1}>
        <Box p={1}>
          <Button variant="contained" className="warningBtn" onClick={_cancel}>
            Back
          </Button>
        </Box>
        <Box p={1}>
          <Button variant="contained" className="successBtn" onClick={_next}>
            Continue
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default CloseTripForm3;
